export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select"])},
        "deselect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselect"])}
      },
      "fr": {
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désélectionner"])}
      }
    }
  })
}